export type PricingTab = 'individual' | 'group';

export const PRICING_TAB_QUERY_KEY = 'tab';
export const DEFAULT_PRICING_TAB: PricingTab = 'individual';

export function parsePricingTab(value: unknown): PricingTab {
  const tab = Array.isArray(value) ? value[0] : value;

  return tab === 'group' || tab === 'individual' ? tab : DEFAULT_PRICING_TAB;
}
